module.exports = __webpack_public_path__ + "static/media/6_file_import_requirements_and_best_practices.2e2c2b1c.png";